import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createSlots as _createSlots, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList } from "vue"

const _hoisted_1 = ["onClick", "id"]
const _hoisted_2 = { class: "d-flex justify-start align-center" }
const _hoisted_3 = { class: "d-flex flex-row justify-space-between align-center" }
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  key: 1,
  class: "text-right",
  colspan: "4"
}
const _hoisted_6 = ["id"]
const _hoisted_7 = ["id"]
const _hoisted_8 = ["id"]
const _hoisted_9 = ["id"]
const _hoisted_10 = ["id"]
const _hoisted_11 = ["id"]
const _hoisted_12 = ["id"]
const _hoisted_13 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_14 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["colspan"]
const _hoisted_17 = ["colspan"]
const _hoisted_18 = {
  key: 0,
  class: "text-right"
}
const _hoisted_19 = {
  key: 1,
  class: "text-right"
}
const _hoisted_20 = { class: "text-right" }
const _hoisted_21 = ["colspan"]
const _hoisted_22 = { class: "text-right" }
const _hoisted_23 = { class: "text-right" }
const _hoisted_24 = { class: "text-right" }
const _hoisted_25 = ["colspan"]
const _hoisted_26 = {
  key: 0,
  class: "text-right"
}
const _hoisted_27 = {
  key: 1,
  class: "text-right"
}
const _hoisted_28 = { class: "text-right" }
const _hoisted_29 = {
  key: 2,
  class: "text-center"
}
const _hoisted_30 = ["colspan"]
const _hoisted_31 = { class: "text-right" }
const _hoisted_32 = { class: "text-right" }
const _hoisted_33 = { class: "text-right" }
const _hoisted_34 = { class: "text-right" }
const _hoisted_35 = ["colspan"]
const _hoisted_36 = {
  key: 0,
  class: "text-right"
}
const _hoisted_37 = {
  key: 1,
  class: "text-right"
}
const _hoisted_38 = { class: "text-right" }
const _hoisted_39 = ["colspan"]
const _hoisted_40 = { class: "text-right" }
const _hoisted_41 = { class: "text-right" }
const _hoisted_42 = { class: "text-right" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = {
  class: "text-right pe-auto",
  colspan: "100"
}
const _hoisted_45 = ["colspan"]
const _hoisted_46 = { class: "text-center" }
const _hoisted_47 = {
  key: 0,
  class: "text-right"
}
const _hoisted_48 = {
  key: 1,
  class: "text-right"
}
const _hoisted_49 = { class: "text-right" }
const _hoisted_50 = ["colspan"]
const _hoisted_51 = {
  key: 0,
  class: "text-right"
}
const _hoisted_52 = {
  key: 1,
  class: "text-right"
}
const _hoisted_53 = {
  key: 2,
  class: "text-right",
  colspan: "20"
}
const _hoisted_54 = ["colspan"]
const _hoisted_55 = {
  key: 0,
  class: "text-right"
}
const _hoisted_56 = { class: "text-right" }
const _hoisted_57 = {
  key: 1,
  class: "text-right",
  colspan: "10"
}
const _hoisted_58 = ["colspan"]
const _hoisted_59 = {
  key: 2,
  colspan: "2"
}
const _hoisted_60 = ["colspan"]
const _hoisted_61 = { class: "text-center" }
const _hoisted_62 = { class: "text-right" }
const _hoisted_63 = { class: "text-right" }
const _hoisted_64 = { class: "text-right" }
const _hoisted_65 = ["colspan"]
const _hoisted_66 = { class: "text-right" }
const _hoisted_67 = { class: "text-right" }
const _hoisted_68 = { class: "text-right" }
const _hoisted_69 = ["colspan"]
const _hoisted_70 = { class: "text-right" }
const _hoisted_71 = { class: "text-right" }
const _hoisted_72 = { class: "text-right" }
const _hoisted_73 = ["colspan"]
const _hoisted_74 = { class: "text-right" }
const _hoisted_75 = { class: "text-right" }
const _hoisted_76 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_AccountableAccountBalanceDetail = _resolveComponent("AccountableAccountBalanceDetail")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_GeneralLedgerAlert = _resolveComponent("GeneralLedgerAlert")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_AccountingItemEditionDialog = _resolveComponent("AccountingItemEditionDialog")!
  const _component_GeneralLedgerExportDialog = _resolveComponent("GeneralLedgerExportDialog")!
  const _component_CreateBankAccount = _resolveComponent("CreateBankAccount")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      (_ctx.isAuthorized)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.fullScreen)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "mb-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "2",
                        class: "d-flex align-center justify-start"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn_back, {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetFullScreenItem())),
                            "data-cy": "GeneralLedger2-back"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "8" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_autocomplete, {
                            items: _ctx.filteredGeneralLedger,
                            modelValue: _ctx.fullScreenItem,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fullScreenItem) = $event)),
                            "item-title": "searchModel",
                            clearable: "",
                            "return-object": true,
                            "auto-select-first": "",
                            label: "Compte",
                            elevation: "0",
                            outlined: "",
                            dense: "",
                            "hide-details": "",
                            class: "pl-2"
                          }, null, 8, ["items", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "2",
                        class: "d-flex align-center justify-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_tooltip, { location: "bottom" }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_btn_prev, _mergeProps(props, {
                                disabled: !_ctx.previousAa,
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPreviousAa())),
                                "data-cy": "GeneralLedger2-detail-back"
                              }), null, 16, ["disabled"])
                            ]),
                            default: _withCtx(() => [
                              _cache[27] || (_cache[27] = _createElementVNode("span", null, "Compte précédent", -1))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_tooltip, { location: "bottom" }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_btn_next, _mergeProps(props, {
                                disabled: !_ctx.nextAa,
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToNextAa())),
                                "data-cy": "GeneralLedger2-detail-next"
                              }), null, 16, ["disabled"])
                            ]),
                            default: _withCtx(() => [
                              _cache[28] || (_cache[28] = _createElementVNode("span", null, "Compte suivant", -1))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_tooltip, { location: "bottom" }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_btn_icon, _mergeProps({
                                icon: 
                                        _ctx.fullScreenItem && _ctx.fullScreenItem.audited
                                            ? '$oss-circle-check'
                                            : '$oss-circle-uncheck'
                                    
                              }, props, {
                                color: 
                                        _ctx.fullScreenItem && _ctx.fullScreenItem.audited
                                            ? 'primary'
                                            : 'secondary'
                                    ,
                                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (
                                        _ctx.updateAccountableAccountAuditedStatus(_ctx.fullScreenItem)
                                    ), ["stop"]))
                              }), null, 16, ["icon", "color"])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(_ctx.fullScreenItem && _ctx.fullScreenItem.audited
                                    ? "Compte révisé"
                                    : "Compte non révisé"), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_component_AccountableAccountBalanceDetail, {
                        addEndColumn: _ctx.nm1,
                        companyId: _ctx.companyId,
                        accountingPeriodId: _ctx.accountingPeriodId,
                        accountingClosingId: _ctx.accountingClosingId,
                        accountableAccountInfo: _ctx.fullScreenItem,
                        inAccountingTransactions: _ctx.fullScreenItem.accountingTransactions,
                        accountableAccountFilter: _ctx.accountableAccountFilter,
                        excludedAccountableAccountFilter: _ctx.excludedAccountableAccountFilter,
                        mode: _ctx.mode,
                        tableHeight: "79vh",
                        search: _ctx.fullScreenItem.search,
                        fourLastColumnsWidth: _ctx.calculedFourLastColumnsWidth,
                        key: _ctx.fullScreenItem.key,
                        startDate: _ctx.startDate,
                        endDate: _ctx.endDate,
                        notReconciliated: _ctx.withoutLettering,
                        onRefresh: _ctx.refresh,
                        "data-cy": "GeneralLedger2-table"
                      }, null, 8, ["addEndColumn", "companyId", "accountingPeriodId", "accountingClosingId", "accountableAccountInfo", "inAccountingTransactions", "accountableAccountFilter", "excludedAccountableAccountFilter", "mode", "search", "fourLastColumnsWidth", "startDate", "endDate", "notReconciliated", "onRefresh"]))
                    ]),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (!_ctx.hideOptions)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        "no-gutters": "",
                        class: "mb-4"
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.isAutonomousUser)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "2",
                                class: "d-flex align-center"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.hideMiscellaneousOperationsBtn)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                                    : (_openBlock(), _createBlock(_component_v_btn_primary, {
                                        key: 1,
                                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.miscellaneousOperationDialog = true)),
                                        block: "",
                                        "data-cy": "GeneralLedger2-add"
                                      }, {
                                        default: _withCtx(() => _cache[29] || (_cache[29] = [
                                          _createTextVNode("Ajouter")
                                        ])),
                                        _: 1
                                      }))
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (!_ctx.isAutonomousUser)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 1,
                                cols: "2",
                                class: "pl-2 d-flex align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn_primary, {
                                    block: "",
                                    disabled: !_ctx.accountableAccountsSelected.length,
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.exportGeneralLedgerDialog = true)),
                                    "data-cy": "GeneralLedger2-export"
                                  }, {
                                    default: _withCtx(() => _cache[30] || (_cache[30] = [
                                      _createTextVNode("Exporter")
                                    ])),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (!_ctx.hideThirdPartySwitch)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 2,
                                cols: "2",
                                class: "d-flex pl-2 align-center"
                              }, {
                                default: _withCtx(() => [
                                  (!_ctx.isAutonomousUser)
                                    ? (_openBlock(), _createBlock(_component_v_switch, {
                                        key: 0,
                                        "hide-details": "",
                                        modelValue: _ctx.thirdParty,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.thirdParty) = $event)),
                                        label: 'Auxiliaires',
                                        class: "pl-2 mt-0",
                                        "data-cy": "GeneralLedger2-thirdParty"
                                      }, null, 8, ["modelValue"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_btn_icon, {
                                    onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.copyToClipboard()), ["stop"])),
                                    class: "ml-3",
                                    icon: "$oss-duplicate"
                                  }),
                                  (_ctx.checkBalances && !_ctx.thirdParty && !_ctx.loading)
                                    ? (_openBlock(), _createBlock(_component_GeneralLedgerAlert, {
                                        key: 1,
                                        check: _ctx.checkBalances
                                      }, null, 8, ["check"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_col, {
                            cols: "3",
                            class: "d-flex align-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                outlined: "",
                                modelValue: _ctx.search,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.search) = $event)),
                                "hide-details": "",
                                label: "Recherche...",
                                type: "text",
                                block: "",
                                class: "pl-2",
                                "data-cy": "GeneralLeger2-search",
                                density: "compact",
                                clearable: "",
                                "append-inner-icon": "$search"
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_menu, {
                                    modelValue: _ctx.menu,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.menu) = $event)),
                                    "close-on-content-click": false,
                                    "nudge-width": 700,
                                    "offset-y": "",
                                    elevation: "1",
                                    location: "start"
                                  }, _createSlots({
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card, {
                                        class: "pa-3 pb-0",
                                        elevation: "1"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "12" }, {
                                                default: _withCtx(() => _cache[31] || (_cache[31] = [
                                                  _createElementVNode("h2", null, "Filtres", -1)
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          (_ctx.isIncomingOutgoingPayment && !_ctx.thirdPartyType)
                                            ? (_openBlock(), _createBlock(_component_v_row, {
                                                key: 0,
                                                "no-gutters": "",
                                                class: "pt-2"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "6" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_switch, {
                                                        "hide-details": "",
                                                        modelValue: _ctx.bncMode,
                                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.bncMode) = $event)),
                                                        label: 'Rapprochement E|D',
                                                        class: "pl-2 mt-0",
                                                        "data-cy": "GeneralLedger2-bncMode"
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  }),
                                                  (_ctx.bncMode)
                                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                                        key: 0,
                                                        cols: "6",
                                                        class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pa-1' : 'px-1')
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_select_filled, {
                                                            items: _ctx.transactionTypes,
                                                            modelValue: _ctx.transactionType,
                                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.transactionType) = $event)),
                                                            label: "Transaction",
                                                            "hide-details": "",
                                                            class: "pl-2",
                                                            "data-cy": "GeneralLedger2-transactionType",
                                                            density: "compact",
                                                            "item-title": "text"
                                                          }, null, 8, ["items", "modelValue"])
                                                        ]),
                                                        _: 1
                                                      }, 8, ["class"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_row, {
                                            "no-gutters": "",
                                            class: "pt-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "3",
                                                class: "d-flex align-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_switch, {
                                                    "hide-details": "",
                                                    modelValue: _ctx.nm1,
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.nm1) = $event)),
                                                    label: 'Ajouter N-1',
                                                    class: "pl-2 mt-0",
                                                    "data-cy": "GeneralLedger2-nm1"
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "4",
                                                class: "d-flex align-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_switch, {
                                                    "hide-details": "",
                                                    disabled: _ctx.nm1,
                                                    modelValue: _ctx.debitCredit,
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.debitCredit) = $event)),
                                                    label: 'Affichage débit/crédit',
                                                    class: "pl-2 mt-0",
                                                    "data-cy": "GeneralLedger2-debitCredit"
                                                  }, null, 8, ["disabled", "modelValue"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "5",
                                                class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pl-2' : '')
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_select_filled, {
                                                    items: _ctx.filters,
                                                    modelValue: _ctx.filter,
                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filter) = $event)),
                                                    label: "Filtre",
                                                    class: "pl-2",
                                                    "hide-details": "",
                                                    "data-cy": "GeneralLedger2-filter",
                                                    density: "compact",
                                                    "item-title": "text"
                                                  }, null, 8, ["items", "modelValue"])
                                                ]),
                                                _: 1
                                              }, 8, ["class"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_row, {
                                            "no-gutters": "",
                                            class: "pt-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "6",
                                                class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pl-2' : ''),
                                                "data-cy": "GeneralLedger2-mode"
                                              }, null, 8, ["class"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_divider),
                                          _createVNode(_component_v_card_actions, { class: "d-flex justify-end w-full" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_btn, {
                                                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.menu = false)),
                                                "data-cy": "GeneralLedger-valid",
                                                size: "small",
                                                variant: "tonal"
                                              }, {
                                                default: _withCtx(() => _cache[32] || (_cache[32] = [
                                                  _createTextVNode(" Valider ")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, [
                                    (
                                            !_ctx.currentUser.profile.name.startsWith(
                                                'customer-autonomous',
                                            )
                                        )
                                      ? {
                                          name: "activator",
                                          fn: _withCtx(({ props }) => [
                                            _createVNode(_component_v_btn_icon, _mergeProps({
                                              icon: "$tune",
                                              elevation: "0",
                                              style: {"margin-top":"-2px"},
                                              color: "secondary"
                                            }, props, {
                                              "data-cy": "GeneralLeger2-filter-icon",
                                              size: "small"
                                            }), null, 16)
                                          ]),
                                          key: "0"
                                        }
                                      : undefined
                                  ]), 1032, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "3",
                            class: "pl-2 d-flex align-center"
                          }, {
                            default: _withCtx(() => [
                              (!_ctx.accountingClosingId)
                                ? (_openBlock(), _createBlock(_component_v_select, {
                                    key: 0,
                                    modelValue: _ctx.startDateLocal,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.startDateLocal) = $event)),
                                    items: _ctx.startMonthlyDates,
                                    label: "Date de début",
                                    "hide-details": "",
                                    "data-cy": "GeneralLeger2-startDateLocal",
                                    density: "compact"
                                  }, null, 8, ["modelValue", "items"]))
                                : _createCommentVNode("", true),
                              (!_ctx.accountingClosingId)
                                ? (_openBlock(), _createBlock(_component_v_select, {
                                    key: 1,
                                    modelValue: _ctx.endDateLocal,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.endDateLocal) = $event)),
                                    items: _ctx.endMonthlyDates,
                                    label: "Date de fin",
                                    "hide-details": "",
                                    class: "ml-2",
                                    "data-cy": "GeneralLeger2-endDateLocal",
                                    density: "compact"
                                  }, null, 8, ["modelValue", "items"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 1,
                        "no-gutters": "",
                        class: "d-flex justify-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_progress_circular, {
                            size: 70,
                            width: 7,
                            color: "primary",
                            indeterminate: "",
                            style: {"margin":"24px"}
                          })
                        ]),
                        _: 1
                      }))
                    : (!_ctx.bncMode)
                      ? (_openBlock(), _createBlock(_component_oss_data_table, {
                          key: 2,
                          modelValue: _ctx.accountableAccountsSelected,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.accountableAccountsSelected) = $event)),
                          headers: _ctx.generalLedgerHeaders,
                          items: _ctx.filteredGeneralLedger,
                          "item-key": 'key',
                          "items-per-page": -1,
                          "hide-default-footer": "",
                          class: "table",
                          striped: true,
                          dense: true,
                          "fixed-header": "",
                          "fixed-footer": true,
                          height: _ctx.dataTableHeight,
                          showSelect: true
                        }, {
                          item: _withCtx((props) => [
                            (_openBlock(), _createElementBlock("tr", {
                              class: "accountableAccountLine",
                              key: props.item.key,
                              onClick: ($event: any) => (_ctx.addRemoveGeneralLedgerExpanded(props.item)),
                              id: props.item.key
                            }, [
                              _createElementVNode("td", _hoisted_2, [
                                _createVNode(_component_v_checkbox, {
                                  class: "pa-0 ma-0 ml-2",
                                  ripple: false,
                                  "hide-details": "",
                                  onClick: _withModifiers(props.onSelect, ["stop"]),
                                  color: "primary",
                                  "data-cy": 
                                        'GeneralLedger2-balance-' + props.item.key + '-checkbox'
                                    ,
                                  "model-value": props.isSelected
                                }, null, 8, ["onClick", "data-cy", "model-value"])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_3, [
                                  _createVNode(_component_v_icon, {
                                    onClick: _withModifiers(($event: any) => {
                                            _ctx.setFullScreenItem(props.item);
                                            _ctx.fullScreen = true;
                                        }, ["stop"]),
                                    "data-cy": 
                                            'GeneralLedger2-balance-' + props.item.key + '-eye'
                                        ,
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => _cache[33] || (_cache[33] = [
                                      _createTextVNode(" $oss-eye ")
                                    ])),
                                    _: 2
                                  }, 1032, ["onClick", "data-cy"]),
                                  (props.item.name.startsWith('512'))
                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 0,
                                        onClick: _withModifiers(($event: any) => (_ctx.openBankAccountWindow(props.item)), ["stop"]),
                                        "data-cy": 
                                            'GeneralLedger2-balance-' + props.item.key + '-edit'
                                        ,
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => _cache[34] || (_cache[34] = [
                                          _createTextVNode(" $oss-edit ")
                                        ])),
                                        _: 2
                                      }, 1032, ["onClick", "data-cy"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_icon, {
                                    size: "small",
                                    "data-cy": 
                                            'GeneralLedger2-balance-' + props.item.key + '-chevron'
                                        
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.isGeneralLedgerExpanded(props.item)
                                                ? "$fa-chevron-up"
                                                : "$fa-chevron-down"), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["data-cy"])
                                ])
                              ]),
                              _createElementVNode("td", {
                                colspan: "4",
                                class: "text-left",
                                style: _normalizeStyle(props.item.name.length === 3 ? 'color:red;' : '')
                              }, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.getTitle(props.item)), 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.getDate(props.item)) + " ", 1),
                                (_ctx.containsErrors(props.item))
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      color: "error",
                                      class: "pl-2",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[35] || (_cache[35] = [
                                        _createTextVNode("$fa-exclamation-triangle")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ], 4),
                              (_ctx.showAuditedAccountableAccounts)
                                ? (_openBlock(), _createElementBlock("td", {
                                    key: 0,
                                    class: "text-center",
                                    id: 'ColumnAudited_' + props.index
                                  }, [
                                    _createVNode(_component_v_btn_icon, {
                                      color: props.item.audited ? 'primary' : 'secondary',
                                      onClick: _withModifiers(($event: any) => (_ctx.updateAccountableAccountAuditedStatus(props.item)), ["stop"]),
                                      icon: 
                                        props.item.audited
                                            ? '$oss-circle-check'
                                            : '$oss-circle-uncheck'
                                    ,
                                      size: "small"
                                    }, null, 8, ["color", "onClick", "icon"])
                                  ], 8, _hoisted_4))
                                : _createCommentVNode("", true),
                              (_ctx.isGeneralLedgerExpanded(props.item))
                                ? (_openBlock(), _createElementBlock("td", _hoisted_5))
                                : (_ctx.nm1)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _createElementVNode("td", {
                                        class: "text-right",
                                        id: 'Column1_' + props.index
                                      }, [
                                        _createElementVNode("strong", {
                                          style: _normalizeStyle(_ctx.getColor(props.item.balance))
                                        }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                            Math.abs(props.item.balance),
                                            undefined,
                                        )), 5)
                                      ], 8, _hoisted_6),
                                      _createElementVNode("td", {
                                        class: "text-right",
                                        id: 'Column2_' + props.index
                                      }, [
                                        _createElementVNode("strong", {
                                          style: _normalizeStyle(_ctx.getColor(props.item.previousBalance))
                                        }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                            Math.abs(props.item.previousBalance),
                                            undefined,
                                        )), 5)
                                      ], 8, _hoisted_7),
                                      _createElementVNode("td", {
                                        class: "text-right",
                                        id: 'Column3_' + props.index
                                      }, [
                                        _createElementVNode("strong", {
                                          style: _normalizeStyle(
                                            _ctx.getColor(
                                                props.item.balance -
                                                    (props.item.previousBalance || 0),
                                            )
                                        )
                                        }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                (props.item.balance || 0) -
                                                    (props.item.previousBalance || 0),
                                                undefined,
                                            )), 5)
                                      ], 8, _hoisted_8),
                                      _createElementVNode("td", {
                                        class: "text-right",
                                        id: 'Column4_' + props.index
                                      }, [
                                        _createElementVNode("strong", {
                                          style: _normalizeStyle(
                                            props.item.balance && props.item.previousBalance
                                                ? _ctx.getColor(
                                                      (props.item.balance -
                                                          props.item.previousBalance) /
                                                          Math.abs(props.item.previousBalance),
                                                  )
                                                : ''
                                        )
                                        }, _toDisplayString(_ctx.percentageVariation(
                                                props.item.previousBalance,
                                                props.item.balance,
                                            )), 5)
                                      ], 8, _hoisted_9)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      (_ctx.debitCredit)
                                        ? (_openBlock(), _createElementBlock("td", {
                                            key: 0,
                                            class: "text-right",
                                            id: 'Column3_' + props.index
                                          }, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("strong", null, _toDisplayString(props.item.debit
                                                ? _ctx.newCommonFormatCurrency(
                                                      props.item.debit,
                                                      undefined,
                                                  )
                                                : "-"), 1)
                                            ])
                                          ], 8, _hoisted_10))
                                        : _createCommentVNode("", true),
                                      (_ctx.debitCredit)
                                        ? (_openBlock(), _createElementBlock("td", {
                                            key: 1,
                                            class: "text-right",
                                            id: 'Column4_' + props.index
                                          }, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("strong", null, _toDisplayString(props.item.credit
                                                ? _ctx.newCommonFormatCurrency(
                                                      props.item.credit,
                                                      undefined,
                                                  )
                                                : "-"), 1)
                                            ])
                                          ], 8, _hoisted_11))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("td", {
                                        class: "text-right",
                                        id: (_ctx.debitCredit ? 'Column5_' : 'Column3_') + props.index
                                      }, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("strong", {
                                            style: _normalizeStyle(_ctx.getColor(props.item.balance))
                                          }, _toDisplayString(props.item.balance
                                                ? _ctx.newCommonFormatCurrency(
                                                      Math.abs(props.item.balance),
                                                      undefined,
                                                  )
                                                : "-"), 5)
                                        ]),
                                        (_ctx.deltaWithCarryForward(props.item))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, " AN : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                props.item.carryForward,
                                                undefined,
                                            )), 1))
                                          : _createCommentVNode("", true),
                                        (_ctx.deltaWithCarryForward(props.item))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Ecart : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                _ctx.deltaWithCarryForward(props.item),
                                                undefined,
                                            )), 1))
                                          : _createCommentVNode("", true)
                                      ], 8, _hoisted_12)
                                    ], 64))
                            ], 8, _hoisted_1)),
                            (_ctx.isGeneralLedgerExpanded(props.item))
                              ? (_openBlock(), _createElementBlock("tr", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.setLastAccoutableAccountInteraction(props.item.key))
                                }, [
                                  _createElementVNode("td", {
                                    colspan: 
                                    _ctx.generalLedgerHeaders.length +
                                    (_ctx.showAuditedAccountableAccounts ? 2 : 1)
                                ,
                                    style: {"padding":"0","background":"#f4f4f4"},
                                    class: "py-2 px-0"
                                  }, [
                                    (_openBlock(), _createBlock(_component_AccountableAccountBalanceDetail, {
                                      addEndColumn: _ctx.nm1,
                                      companyId: _ctx.companyId,
                                      accountingPeriodId: _ctx.accountingPeriodId,
                                      accountingClosingId: _ctx.accountingClosingId,
                                      accountableAccountInfo: props.item,
                                      inAccountingTransactions: props.item.accountingTransactions,
                                      accountableAccountFilter: _ctx.accountableAccountFilter,
                                      excludedAccountableAccountFilter: 
                                        _ctx.excludedAccountableAccountFilter
                                    ,
                                      mode: _ctx.mode,
                                      search: props.item.search,
                                      fourLastColumnsWidth: _ctx.calculedFourLastColumnsWidth,
                                      key: 'AABD_' + props,
                                      startDate: _ctx.startDate,
                                      endDate: _ctx.endDate,
                                      notReconciliated: _ctx.withoutLettering,
                                      onRefresh: _ctx.refresh,
                                      onTableHeight: ($event: any) => (_ctx.addAdditionalHeight($event, props.item)),
                                      thirdPartyMode: _ctx.thirdParty
                                    }, null, 8, ["addEndColumn", "companyId", "accountingPeriodId", "accountingClosingId", "accountableAccountInfo", "inAccountingTransactions", "accountableAccountFilter", "excludedAccountableAccountFilter", "mode", "search", "fourLastColumnsWidth", "startDate", "endDate", "notReconciliated", "onRefresh", "onTableHeight", "thirdPartyMode"]))
                                  ], 8, _hoisted_16)
                                ], 8, _hoisted_15))
                              : _createCommentVNode("", true)
                          ]),
                          "body.append": _withCtx(() => [
                            (_ctx.generalLedger.length > 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_ctx.search)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _withDirectives(_createElementVNode("tr", null, [
                                          _createElementVNode("th", {
                                            class: "text-right",
                                            colspan: _ctx.showAuditedAccountableAccounts ? 7 : 6
                                          }, " Total recherche ", 8, _hoisted_17),
                                          (_ctx.debitCredit)
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_18, [
                                                _createElementVNode("strong", null, _toDisplayString(_ctx.totalBalanceDebit
                                                ? _ctx.newCommonFormatCurrency(
                                                      _ctx.totalBalanceDebit,
                                                      undefined,
                                                  )
                                                : "-"), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.debitCredit)
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_19, [
                                                _createElementVNode("strong", null, _toDisplayString(_ctx.totalBalanceCredit
                                                ? _ctx.newCommonFormatCurrency(
                                                      _ctx.totalBalanceCredit,
                                                      undefined,
                                                  )
                                                : "-"), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("th", _hoisted_20, [
                                            _createElementVNode("strong", {
                                              style: _normalizeStyle(_ctx.getColor(_ctx.totalBalance))
                                            }, _toDisplayString(_ctx.totalBalance
                                                ? _ctx.newCommonFormatCurrency(_ctx.totalBalance, undefined)
                                                : "-"), 5)
                                          ])
                                        ], 512), [
                                          [_vShow, !_ctx.nm1]
                                        ]),
                                        _withDirectives(_createElementVNode("tr", null, [
                                          _createElementVNode("th", {
                                            class: "text-right",
                                            colspan: _ctx.showAuditedAccountableAccounts ? 7 : 6
                                          }, " Total recherche ", 8, _hoisted_21),
                                          _createElementVNode("th", _hoisted_22, [
                                            _createElementVNode("strong", {
                                              style: _normalizeStyle(_ctx.getColor(_ctx.totalBalance))
                                            }, _toDisplayString(_ctx.totalBalance
                                                ? _ctx.newCommonFormatCurrency(_ctx.totalBalance, undefined)
                                                : "-"), 5)
                                          ]),
                                          _createElementVNode("th", _hoisted_23, [
                                            _createElementVNode("strong", {
                                              style: _normalizeStyle(_ctx.getColor(_ctx.totalPreviousBalance))
                                            }, _toDisplayString(_ctx.totalPreviousBalance
                                                ? _ctx.newCommonFormatCurrency(
                                                      _ctx.totalPreviousBalance,
                                                      undefined,
                                                  )
                                                : "-"), 5)
                                          ]),
                                          _createElementVNode("th", _hoisted_24, [
                                            _createElementVNode("strong", {
                                              style: _normalizeStyle(_ctx.getColor(_ctx.totalBalance - _ctx.totalPreviousBalance))
                                            }, _toDisplayString(_ctx.totalBalance - _ctx.totalPreviousBalance
                                                    ? _ctx.newCommonFormatCurrency(
                                                          _ctx.totalBalance - _ctx.totalPreviousBalance,
                                                          undefined,
                                                      )
                                                    : "-"), 5)
                                          ]),
                                          _cache[36] || (_cache[36] = _createElementVNode("th", { colspan: "10" }, null, -1))
                                        ], 512), [
                                          [_vShow, _ctx.nm1]
                                        ])
                                      ], 64))
                                    : (_ctx.accountableAccountsSelected.length)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _withDirectives(_createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                              class: "text-right",
                                              colspan: _ctx.showAuditedAccountableAccounts ? 7 : 6
                                            }, " Total sélection ", 8, _hoisted_25),
                                            (_ctx.debitCredit)
                                              ? (_openBlock(), _createElementBlock("th", _hoisted_26, [
                                                  _createElementVNode("strong", null, _toDisplayString(_ctx.totalAccountableAccountsSelectedDebit
                                                ? _ctx.newCommonFormatCurrency(
                                                      _ctx.totalAccountableAccountsSelectedDebit,
                                                      undefined,
                                                  )
                                                : "-"), 1)
                                                ]))
                                              : _createCommentVNode("", true),
                                            (_ctx.debitCredit)
                                              ? (_openBlock(), _createElementBlock("th", _hoisted_27, [
                                                  _createElementVNode("strong", null, _toDisplayString(_ctx.totalAccountableAccountsSelectedCredit
                                                ? _ctx.newCommonFormatCurrency(
                                                      _ctx.totalAccountableAccountsSelectedCredit,
                                                      undefined,
                                                  )
                                                : "-"), 1)
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("th", _hoisted_28, [
                                              _createElementVNode("strong", {
                                                style: _normalizeStyle(
                                                _ctx.getColor(_ctx.totalAccountableAccountsSelectedBalance)
                                            )
                                              }, _toDisplayString(_ctx.totalAccountableAccountsSelectedBalance
                                                    ? _ctx.newCommonFormatCurrency(
                                                          _ctx.totalAccountableAccountsSelectedBalance,
                                                          undefined,
                                                      )
                                                    : "-"), 5)
                                            ]),
                                            (_ctx.showAuditedAccountableAccounts)
                                              ? (_openBlock(), _createElementBlock("th", _hoisted_29))
                                              : _createCommentVNode("", true)
                                          ], 512), [
                                            [_vShow, !_ctx.nm1]
                                          ]),
                                          _withDirectives(_createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                              class: "text-right",
                                              colspan: _ctx.showAuditedAccountableAccounts ? 7 : 6
                                            }, " Total sélection ", 8, _hoisted_30),
                                            _createElementVNode("th", _hoisted_31, [
                                              _createElementVNode("strong", {
                                                style: _normalizeStyle(
                                                _ctx.getColor(_ctx.totalAccountableAccountsSelectedBalance)
                                            )
                                              }, _toDisplayString(_ctx.totalAccountableAccountsSelectedBalance
                                                    ? _ctx.newCommonFormatCurrency(
                                                          _ctx.totalAccountableAccountsSelectedBalance,
                                                          undefined,
                                                      )
                                                    : "-"), 5)
                                            ]),
                                            _createElementVNode("th", _hoisted_32, [
                                              _createElementVNode("strong", {
                                                style: _normalizeStyle(
                                                _ctx.getColor(
                                                    _ctx.totalAccountableAccountsSelectedDebitMCreditPreviousBalance,
                                                )
                                            )
                                              }, _toDisplayString(_ctx.totalAccountableAccountsSelectedDebitMCreditPreviousBalance
                                                    ? _ctx.newCommonFormatCurrency(
                                                          _ctx.totalAccountableAccountsSelectedDebitMCreditPreviousBalance,
                                                          undefined,
                                                      )
                                                    : "-"), 5)
                                            ]),
                                            _createElementVNode("th", _hoisted_33, [
                                              _createElementVNode("strong", {
                                                style: _normalizeStyle(
                                                _ctx.getColor(
                                                    _ctx.totalAccountableAccountsSelectedBalance -
                                                        _ctx.totalAccountableAccountsSelectedDebitMCreditPreviousBalance,
                                                )
                                            )
                                              }, _toDisplayString(_ctx.totalAccountableAccountsSelectedBalance -
                                                _ctx.totalAccountableAccountsSelectedDebitMCreditPreviousBalance
                                                    ? _ctx.newCommonFormatCurrency(
                                                          _ctx.totalAccountableAccountsSelectedBalance -
                                                              _ctx.totalAccountableAccountsSelectedDebitMCreditPreviousBalance,
                                                          undefined,
                                                      )
                                                    : "-"), 5)
                                            ]),
                                            _createElementVNode("td", _hoisted_34, [
                                              _createElementVNode("strong", {
                                                style: _normalizeStyle(
                                                _ctx.totalAccountableAccountsSelectedBalance &&
                                                _ctx.totalAccountableAccountsSelectedDebitMCreditPreviousBalance
                                                    ? _ctx.getColor(
                                                          (_ctx.totalAccountableAccountsSelectedBalance -
                                                              _ctx.totalAccountableAccountsSelectedDebitMCreditPreviousBalance) /
                                                              _ctx.totalAccountableAccountsSelectedDebitMCreditPreviousBalance,
                                                      )
                                                    : ''
                                            )
                                              }, _toDisplayString(_ctx.percentageVariation(
                                                    _ctx.totalAccountableAccountsSelectedDebitMCreditPreviousBalance,
                                                    _ctx.totalAccountableAccountsSelectedBalance,
                                                )), 5)
                                            ])
                                          ], 512), [
                                            [_vShow, _ctx.nm1]
                                          ])
                                        ], 64))
                                      : (_ctx.thirdParty)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thirdPartyAccounts.slice(
                                        0,
                                        _ctx.maxThirdPartyAccsSummaryVisible,
                                    ), (account) => {
                                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                _withDirectives(_createElementVNode("tr", null, [
                                                  _createElementVNode("th", {
                                                    class: "text-right",
                                                    colspan: _ctx.showAuditedAccountableAccounts ? 7 : 6
                                                  }, _toDisplayString(_ctx.debitCredit
                                                    ? `Totaux ${account}`
                                                    : `Total ${account}`), 9, _hoisted_35),
                                                  (_ctx.debitCredit)
                                                    ? (_openBlock(), _createElementBlock("th", _hoisted_36, [
                                                        _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.getTotalDebitThirdParty(account),
                                                    undefined,
                                                )), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.debitCredit)
                                                    ? (_openBlock(), _createElementBlock("th", _hoisted_37, [
                                                        _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.getTotalCreditThirdParty(account),
                                                    undefined,
                                                )), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  _createElementVNode("th", _hoisted_38, [
                                                    _createElementVNode("strong", {
                                                      style: _normalizeStyle(_ctx.getColor(_ctx.total401Balance))
                                                    }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.getTotalBalanceThirdParty(account),
                                                    undefined,
                                                )), 5)
                                                  ])
                                                ], 512), [
                                                  [_vShow, !_ctx.nm1 && !_ctx.hideBodyAppend]
                                                ]),
                                                _withDirectives(_createElementVNode("tr", null, [
                                                  _createElementVNode("th", {
                                                    class: "text-right",
                                                    colspan: _ctx.showAuditedAccountableAccounts ? 7 : 6
                                                  }, " Total " + _toDisplayString(account), 9, _hoisted_39),
                                                  _createElementVNode("th", _hoisted_40, [
                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.getTotalBalanceThirdParty(account),
                                                    undefined,
                                                )), 1)
                                                  ]),
                                                  _createElementVNode("th", _hoisted_41, [
                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.getTotalPreviousBalanceThirdParty(account),
                                                    undefined,
                                                )), 1)
                                                  ]),
                                                  _createElementVNode("th", _hoisted_42, [
                                                    _createElementVNode("strong", {
                                                      style: _normalizeStyle(
                                                    _ctx.getColor(_ctx.getTotalDiffBalanceThirdParty(account))
                                                )
                                                    }, _toDisplayString(_ctx.getTotalDiffBalanceThirdParty(account)
                                                        ? _ctx.newCommonFormatCurrency(
                                                              _ctx.getTotalDiffBalanceThirdParty(
                                                                  account,
                                                              ),
                                                              undefined,
                                                          )
                                                        : "-"), 5)
                                                  ]),
                                                  _cache[37] || (_cache[37] = _createElementVNode("th", { colspan: "10" }, null, -1))
                                                ], 512), [
                                                  [_vShow, _ctx.nm1 && !_ctx.hideBodyAppend]
                                                ])
                                              ], 64))
                                            }), 256)),
                                            (
                                        _ctx.thirdPartyAccounts.length >= _ctx.maxThirdPartyAccsSummaryVisible
                                    )
                                              ? _withDirectives((_openBlock(), _createElementBlock("tr", _hoisted_43, [
                                                  _createElementVNode("th", _hoisted_44, [
                                                    _createElementVNode("a", {
                                                      role: "button",
                                                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.toggleVisibleThirdPartyAccsSummary()))
                                                    }, _toDisplayString(_ctx.maxThirdPartyAccsSummaryVisible <
                                                    _ctx.thirdPartyAccounts.length
                                                        ? "Afficher plus..."
                                                        : "Afficher moins..."), 1)
                                                  ])
                                                ], 512)), [
                                                  [_vShow, !_ctx.hideBodyAppend]
                                                ])
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                            _withDirectives(_createElementVNode("tr", null, [
                                              _createElementVNode("th", {
                                                colspan: _ctx.showAuditedAccountableAccounts ? 6 : 5
                                              }, null, 8, _hoisted_45),
                                              _createElementVNode("th", _hoisted_46, [
                                                _createElementVNode("strong", null, [
                                                  _createVNode(_component_v_icon, {
                                                    class: "mr-2",
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[38] || (_cache[38] = [
                                                      _createTextVNode("$oss-circle-check")
                                                    ])),
                                                    _: 1
                                                  }),
                                                  _createTextVNode(_toDisplayString(_ctx.auditedAccountableAccountsFraction), 1)
                                                ])
                                              ]),
                                              (_ctx.debitCredit)
                                                ? (_openBlock(), _createElementBlock("th", _hoisted_47, [
                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.totalBalanceDebit
                                                ? _ctx.newCommonFormatCurrency(
                                                      _ctx.totalBalanceDebit,
                                                      undefined,
                                                  )
                                                : "-"), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (_ctx.debitCredit)
                                                ? (_openBlock(), _createElementBlock("th", _hoisted_48, [
                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.totalBalanceCredit
                                                ? _ctx.newCommonFormatCurrency(
                                                      _ctx.totalBalanceCredit,
                                                      undefined,
                                                  )
                                                : "-"), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("th", _hoisted_49, [
                                                _createElementVNode("strong", {
                                                  style: _normalizeStyle(_ctx.getColor(_ctx.totalBalance))
                                                }, _toDisplayString(_ctx.totalBalance
                                                ? _ctx.newCommonFormatCurrency(_ctx.totalBalance, undefined)
                                                : "-"), 5)
                                              ])
                                            ], 512), [
                                              [_vShow, !_ctx.nm1]
                                            ]),
                                            _withDirectives(_createElementVNode("tr", null, [
                                              _createElementVNode("th", {
                                                class: "text-right",
                                                colspan: _ctx.showAuditedAccountableAccounts ? 7 : 6
                                              }, " Total charges ", 8, _hoisted_50),
                                              (_ctx.debitCredit)
                                                ? (_openBlock(), _createElementBlock("th", _hoisted_51, [
                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.total6Balance
                                                ? _ctx.newCommonFormatCurrency(_ctx.total6Balance, undefined)
                                                : "-"), 1)
                                                  ]))
                                                : (_openBlock(), _createElementBlock("th", _hoisted_52, [
                                                    _createElementVNode("strong", {
                                                      style: _normalizeStyle(_ctx.getColor(-_ctx.total6Balance))
                                                    }, _toDisplayString(_ctx.total6Balance
                                                ? _ctx.newCommonFormatCurrency(-_ctx.total6Balance, undefined)
                                                : "-"), 5)
                                                  ])),
                                              (_ctx.debitCredit)
                                                ? (_openBlock(), _createElementBlock("th", _hoisted_53))
                                                : _createCommentVNode("", true)
                                            ], 512), [
                                              [_vShow, !_ctx.nm1 && !_ctx.hideBodyAppend]
                                            ]),
                                            _withDirectives(_createElementVNode("tr", null, [
                                              _createElementVNode("th", {
                                                class: "text-right",
                                                colspan: _ctx.showAuditedAccountableAccounts ? 7 : 6
                                              }, " Total produits ", 8, _hoisted_54),
                                              (_ctx.debitCredit)
                                                ? (_openBlock(), _createElementBlock("th", _hoisted_55))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("th", _hoisted_56, [
                                                _createElementVNode("strong", null, _toDisplayString(_ctx.total7Balance
                                                ? _ctx.newCommonFormatCurrency(-_ctx.total7Balance, undefined)
                                                : "-"), 1)
                                              ]),
                                              (_ctx.debitCredit)
                                                ? (_openBlock(), _createElementBlock("th", _hoisted_57))
                                                : _createCommentVNode("", true)
                                            ], 512), [
                                              [_vShow, !_ctx.nm1 && !_ctx.hideBodyAppend]
                                            ]),
                                            _withDirectives(_createElementVNode("tr", null, [
                                              _createElementVNode("th", {
                                                class: "text-right",
                                                colspan: _ctx.showAuditedAccountableAccounts ? 7 : 6
                                              }, _toDisplayString(_ctx.profitOrLossTitle), 9, _hoisted_58),
                                              (_ctx.profitOrLoss < 0)
                                                ? (_openBlock(), _createElementBlock("th", {
                                                    key: 0,
                                                    style: _normalizeStyle(_ctx.debitCredit ? '' : _ctx.getColor(-_ctx.profitOrLoss)),
                                                    class: "text-right"
                                                  }, [
                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.profitOrLoss < 0
                                                ? _ctx.newCommonFormatCurrency(-_ctx.profitOrLoss, undefined)
                                                : "-"), 1)
                                                  ], 4))
                                                : (_ctx.profitOrLoss > 0)
                                                  ? (_openBlock(), _createElementBlock("th", {
                                                      key: 1,
                                                      style: _normalizeStyle(_ctx.debitCredit ? '' : _ctx.getColor(-_ctx.profitOrLoss)),
                                                      class: "text-right",
                                                      colspan: "2"
                                                    }, [
                                                      _createElementVNode("strong", null, _toDisplayString(_ctx.profitOrLoss > 0
                                                ? _ctx.newCommonFormatCurrency(-_ctx.profitOrLoss, undefined)
                                                : "-"), 1)
                                                    ], 4))
                                                  : (_openBlock(), _createElementBlock("th", _hoisted_59)),
                                              _cache[39] || (_cache[39] = _createElementVNode("th", { colspan: "20" }, null, -1))
                                            ], 512), [
                                              [_vShow, !_ctx.nm1 && !_ctx.hideBodyAppend]
                                            ]),
                                            _withDirectives(_createElementVNode("tr", null, [
                                              _createElementVNode("th", {
                                                colspan: _ctx.showAuditedAccountableAccounts ? 6 : 5
                                              }, null, 8, _hoisted_60),
                                              _createElementVNode("th", _hoisted_61, [
                                                _createElementVNode("strong", null, [
                                                  _createVNode(_component_v_icon, {
                                                    class: "mr-2",
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[40] || (_cache[40] = [
                                                      _createTextVNode("$oss-circle-check")
                                                    ])),
                                                    _: 1
                                                  }),
                                                  _createTextVNode(_toDisplayString(_ctx.auditedAccountableAccountsFraction), 1)
                                                ])
                                              ]),
                                              _createElementVNode("th", _hoisted_62, [
                                                _createElementVNode("strong", {
                                                  style: _normalizeStyle(_ctx.getColor(_ctx.totalBalance))
                                                }, _toDisplayString(_ctx.totalBalance
                                                ? _ctx.newCommonFormatCurrency(_ctx.totalBalance, undefined)
                                                : "-"), 5)
                                              ]),
                                              _createElementVNode("th", _hoisted_63, [
                                                _createElementVNode("strong", {
                                                  style: _normalizeStyle(_ctx.getColor(_ctx.totalPreviousBalance))
                                                }, _toDisplayString(_ctx.totalPreviousBalance
                                                ? _ctx.newCommonFormatCurrency(
                                                      _ctx.totalPreviousBalance,
                                                      undefined,
                                                  )
                                                : "-"), 5)
                                              ]),
                                              _createElementVNode("th", _hoisted_64, [
                                                _createElementVNode("strong", {
                                                  style: _normalizeStyle(_ctx.getColor(_ctx.totalBalance - _ctx.totalPreviousBalance))
                                                }, _toDisplayString(_ctx.totalBalance - _ctx.totalPreviousBalance
                                                    ? _ctx.newCommonFormatCurrency(
                                                          _ctx.totalBalance - _ctx.totalPreviousBalance,
                                                          undefined,
                                                      )
                                                    : "-"), 5)
                                              ]),
                                              _cache[41] || (_cache[41] = _createElementVNode("th", { colspan: "10" }, null, -1))
                                            ], 512), [
                                              [_vShow, _ctx.nm1]
                                            ]),
                                            _withDirectives(_createElementVNode("tr", null, [
                                              _createElementVNode("th", {
                                                class: "text-right",
                                                colspan: _ctx.showAuditedAccountableAccounts ? 7 : 6
                                              }, " Total charges ", 8, _hoisted_65),
                                              _createElementVNode("th", _hoisted_66, [
                                                _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.total6Balance, undefined)), 1)
                                              ]),
                                              _createElementVNode("th", _hoisted_67, [
                                                _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                _ctx.total6PreviousBalance,
                                                undefined,
                                            )), 1)
                                              ]),
                                              _createElementVNode("th", _hoisted_68, [
                                                _createElementVNode("strong", {
                                                  style: _normalizeStyle(_ctx.getColor(_ctx.total6PreviousBalance - _ctx.total6Balance))
                                                }, _toDisplayString(_ctx.total6PreviousBalance - _ctx.total6Balance
                                                    ? _ctx.newCommonFormatCurrency(
                                                          _ctx.total6PreviousBalance - _ctx.total6Balance,
                                                          undefined,
                                                      )
                                                    : "-"), 5)
                                              ]),
                                              _cache[42] || (_cache[42] = _createElementVNode("th", { colspan: "10" }, null, -1))
                                            ], 512), [
                                              [_vShow, _ctx.nm1 && !_ctx.hideBodyAppend]
                                            ]),
                                            _withDirectives(_createElementVNode("tr", null, [
                                              _createElementVNode("th", {
                                                class: "text-right",
                                                colspan: _ctx.showAuditedAccountableAccounts ? 7 : 6
                                              }, " Total produits ", 8, _hoisted_69),
                                              _createElementVNode("th", _hoisted_70, [
                                                _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.total7Balance, undefined)), 1)
                                              ]),
                                              _createElementVNode("th", _hoisted_71, [
                                                _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                _ctx.total7PreviousBalance,
                                                undefined,
                                            )), 1)
                                              ]),
                                              _createElementVNode("th", _hoisted_72, [
                                                _createElementVNode("strong", {
                                                  style: _normalizeStyle(_ctx.getColor(_ctx.total7PreviousBalance - _ctx.total7Balance))
                                                }, _toDisplayString(_ctx.total7PreviousBalance - _ctx.total7Balance
                                                    ? _ctx.newCommonFormatCurrency(
                                                          _ctx.total7PreviousBalance - _ctx.total7Balance,
                                                          undefined,
                                                      )
                                                    : "-"), 5)
                                              ]),
                                              _cache[43] || (_cache[43] = _createElementVNode("th", { colspan: "10" }, null, -1))
                                            ], 512), [
                                              [_vShow, _ctx.nm1 && !_ctx.hideBodyAppend]
                                            ]),
                                            _withDirectives(_createElementVNode("tr", null, [
                                              _createElementVNode("th", {
                                                class: "text-right",
                                                colspan: _ctx.showAuditedAccountableAccounts ? 7 : 6
                                              }, _toDisplayString("Bénéfice / Perte"), 8, _hoisted_73),
                                              _createElementVNode("th", _hoisted_74, [
                                                _createElementVNode("strong", {
                                                  style: _normalizeStyle(_ctx.getColor(-_ctx.profitOrLoss))
                                                }, _toDisplayString(_ctx.profitOrLoss
                                                ? _ctx.newCommonFormatCurrency(-_ctx.profitOrLoss)
                                                : "-"), 5)
                                              ]),
                                              _createElementVNode("th", _hoisted_75, [
                                                _createElementVNode("strong", {
                                                  style: _normalizeStyle(_ctx.getColor(_ctx.profitOrLossPreviousBalance))
                                                }, _toDisplayString(_ctx.profitOrLossPreviousBalance
                                                ? _ctx.newCommonFormatCurrency(
                                                      _ctx.profitOrLossPreviousBalance,
                                                  )
                                                : "-"), 5)
                                              ]),
                                              _createElementVNode("th", _hoisted_76, [
                                                _createElementVNode("strong", {
                                                  style: _normalizeStyle(
                                                _ctx.getColor(_ctx.profitOrLossPreviousBalance - _ctx.profitOrLoss)
                                            )
                                                }, _toDisplayString(_ctx.profitOrLossPreviousBalance - _ctx.profitOrLoss
                                                    ? _ctx.newCommonFormatCurrency(
                                                          _ctx.profitOrLossPreviousBalance -
                                                              _ctx.profitOrLoss,
                                                          undefined,
                                                      )
                                                    : "-"), 5)
                                              ]),
                                              _cache[44] || (_cache[44] = _createElementVNode("th", { colspan: "10" }, null, -1))
                                            ], 512), [
                                              [_vShow, _ctx.nm1 && !_ctx.hideBodyAppend]
                                            ])
                                          ], 64))
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "headers", "items", "height"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _cache[45] || (_cache[45] = _createElementVNode("p", null, "Association mouvements bancaires et factures", -1)),
                          _createVNode(_component_AccountableAccountBalanceDetail, {
                            companyId: _ctx.companyId,
                            accountingPeriodId: _ctx.accountingPeriodId,
                            accountingClosingId: _ctx.accountingClosingId,
                            accountableAccountInfo: _ctx.bncAccountableAccountInfo,
                            transactionType: _ctx.bncMode ? _ctx.transactionType : 'ALL',
                            inAccountingTransactions: [],
                            mode: _ctx.mode,
                            startDate: _ctx.startDate,
                            endDate: _ctx.endDate
                          }, null, 8, ["companyId", "accountingPeriodId", "accountingClosingId", "accountableAccountInfo", "transactionType", "mode", "startDate", "endDate"])
                        ], 64)),
                  _createVNode(_component_AccountingItemEditionDialog, {
                    modelValue: _ctx.miscellaneousOperationDialog,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.miscellaneousOperationDialog) = $event)),
                    companyId: _ctx.companyId,
                    onUpsert: _cache[22] || (_cache[22] = ($event: any) => (_ctx.refresh()))
                  }, null, 8, ["modelValue", "companyId"]),
                  (_ctx.exportGeneralLedgerDialog)
                    ? (_openBlock(), _createBlock(_component_GeneralLedgerExportDialog, {
                        key: 4,
                        exportGeneralLedgerDialog: _ctx.exportGeneralLedgerDialog,
                        "onUpdate:exportGeneralLedgerDialog": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.exportGeneralLedgerDialog) = $event)),
                        companyId: _ctx.companyId,
                        accountingPeriodId: _ctx.accountingPeriodId,
                        inStartDate: _ctx.startDate,
                        inEndDate: _ctx.endDate,
                        thirdParty: _ctx.thirdParty,
                        fromExportAccounting: false,
                        accountableAccountsSelected: _ctx.accountableAccountsSelected,
                        onExportFileFinished: _cache[24] || (_cache[24] = ($event: any) => (_ctx.exportGeneralLedgerDialog = false))
                      }, null, 8, ["exportGeneralLedgerDialog", "companyId", "accountingPeriodId", "inStartDate", "inEndDate", "thirdParty", "accountableAccountsSelected"]))
                    : _createCommentVNode("", true)
                ], 64)),
            _createVNode(_component_CreateBankAccount, {
              active: _ctx.bankAccountDialog,
              "onUpdate:active": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.bankAccountDialog) = $event)),
              companyId: _ctx.companyId,
              bankId: _ctx.selectedBankId,
              bankAccounts: _ctx.bankAccounts,
              onCloseDialog: _cache[26] || (_cache[26] = ($event: any) => (_ctx.closeDialog())),
              onUpserted: _ctx.onBankAccountUpserted
            }, null, 8, ["active", "companyId", "bankId", "bankAccounts", "onUpserted"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}